import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CommercialServiceQueuePage } from '../modules/ComponentsLibrary/CommercialServiceQueue';

export const Route = createFileRoute('/commercial-service-queue')({
  component: RouteComponent,
  // workOrder opens an inbound ServiceChannel work order's drawer. The Chat
  // card links here with it, before and after the work order is decided.
  // On phones, `job` opens that call as a page, so Back and refresh keep it.
  validateSearch: z.object({
    workOrder: z.coerce.number().int().positive().optional().catch(undefined),
    job: z.coerce.number().int().positive().optional().catch(undefined),
  }),
  head() {
    return {
      meta: [{ title: 'Commercial Service Queue' }],
    };
  },
});

function RouteComponent() {
  return <CommercialServiceQueuePage />;
}
